<template>
  <div class="split-apply-info">
    <div class="info-item">
      <div class="item-header">审批进度</div>
      <apply-progress :info="info" />
    </div>
    <div class="info-item">
      <div class="item-header">
        账户信息
        <!-- 提交后撤回 -->
        <el-button v-if="info.auditStatus == 0" type="primary" size="small" @click="widthdraw">撤回提交</el-button>
        <!-- 驳回/撤回后 重新提交 -->
        <el-button v-else-if="info.auditStatus >= 2" type="primary" size="small" @click="$emit('resubmit')">重新提交</el-button>
        <el-button v-if="info.auditStatus === 1" type="primary" size="small" @click="modifyInvoice">修改开票信息</el-button>
        <!-- <el-button type="primary" size="small" @click="modifyInvoice">修改开票信息</el-button> -->
      </div>
      <div class="account-info">
        <div class="item-wrap" v-for="i in accountInfos" :key="i.key">
          <div class="label" :style="{ width: i.width }">{{ i.label }}：</div>
          <div class="value md-ellipsis" :title="info[i.key]">{{ info[i.key] }}</div>
        </div>
      </div>
    </div>
    <div class="info-item">
      <div class="item-header">审批记录</div>
      <div class="apply-logs">
        <div class="log-item" v-for="ap in info.approveList" :key="ap.id">
          <i class="log-icon" :class="logIcons[ap.auditStatus]" :style="{ color: logColors[ap.auditStatus] }"></i>
          <div class="log-info">
            <div class="info-main">
              <p>{{ ap.uname }}</p>
              <p v-if="ap.msgInfo">{{ ap.msgInfo }}</p>
              <p v-if="ap.reason" :style="{ color: ap.auditStatus == 2 ? '#F22020' : '' }">备注：{{ ap.reason }}</p>
            </div>
            <div class="operationTime">{{ ap.operationTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showModifyInvoice" title="修改开票信息" @close="closeModel" width="500px">
      <el-form ref="form" size="medium" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="开票方式" prop="openInvoiceType">
          <el-checkbox-group v-model="form.openInvoiceType">
            <el-checkbox :label="1">电子发票</el-checkbox>
            <el-checkbox :label="2">纸质发票</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="开票售后电话" prop="invoiceAfterSalePhone">
          <el-input v-model="form.invoiceAfterSalePhone" placeholder="请输入售后电话" maxlength="11"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" @click="closeModel">取消</el-button>
        <el-button type="primary" size="small" @click="saveInvoice">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { MessageBox } from "element-ui"
import { SplitService } from "../../apis/split"
import applyProgress from "./apply-progress.vue"
export default {
  components: { applyProgress },
  props: ["info"],
  data() {
    return {
      //         { label: "APP终端号", key: "appTerminalId" },
        // { label: "PC终端号", key: "pcTerminalId" },
      accountInfos: [
        { label: "状态", key: "auditStatusLabel" },
        { label: "账户类型", key: "accountTypeLabel" },
        { label: "商户号", key: "appMerchantId" },
        { label: "开户名称", key: "accountName" },
        { label: "申请时间", key: "applicationTime" },
        { label: "联系人", key: "contactName" },
        { label: "联系邮箱", key: "contactEmail" },
        { label: "联系方式", key: "contactWay" },
        { label: "开票方式", key: "openInvoiceTypeLabel" },
        { label: "开票售后电话", key: "invoiceAfterSalePhone" },
      ],
      logIcons: [
        "el-icon-time",  // 0: "审批中"
        "el-icon-circle-check",  // 1: "已通过"
        "el-icon-circle-close",  // 2: "已驳回"
        "el-icon-remove-outline",  // 3: "已撤回"
      ],
      logColors: [
        "#409EFF",  // 0: "审批中"
        "#67C23A",  // 1: "已通过"
        "#F56C6C",  // 2: "已驳回"
        "#909399",  // 3: "已撤回"
      ],
      showModifyInvoice: false,
      form: {
        openInvoiceType: [0],
        invoiceAfterSalePhone: "",
      },
      rules: {
        openInvoiceType: [{ required: true, type: "array", message: "请选择开票方式" }],
        invoiceAfterSalePhone: [{ required: true, message: '请输入开票售后电话' }],
      }
    }
  },

  methods: {
    widthdraw() {
      MessageBox.confirm("确定撤销分账申请吗？", "注意", { type: "warning" }).then(() => {
        SplitService.changeSplitApplyStatus(this.info.id, 3).then(res => {
          this.$emit("reloadInfo");
        }).catch(() => {
          this.$emit("reloadInfo");
        })
      })
    },
    modifyInvoice() {
      this.form = this.info;
      if (this.form.openInvoiceType[0] === 0) this.form.openInvoiceType = [1]; // 旧数据默认是0，[0]
      this.showModifyInvoice = true;
    },
    closeModel() {
      this.showModifyInvoice = false;
      this.$refs.form.clearValidate();
    },
    async saveInvoice() {
      await this.$refs.form.validate();
      const obj = Object.assign({}, this.form);
      const type = obj.openInvoiceType;
      obj.openInvoiceType = type.length === 2 ? 3 : Number(type); // 都选的话type是3
      this.$emit("save", obj);
      this.showModifyInvoice = false;
    },
  }
}
</script>
<style lang="scss" scoped>
.split-apply-info {
  height: 100%;
  background-color: #f0f2f5;
}
.item-header {
  padding: 20px 36px;
  position: relative;
  border-bottom: 1px solid #e8e8e8;
  font-size: 18px;
  line-height: 20px;
  &::before {
    content: "";
    position: absolute;
    width: 6px;
    height: 22px;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #1b9aee;
  }
  .el-button {
    // position: absolute;
    float: right;
    margin-left: 20px;
    // right: 20px;
    // top: 50%;
    // transform: translateY(-50%);
  }
}
.info-item {
  margin-bottom: 10px;
  background-color: #fff;
}

.account-info {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  padding: 20px 30px;
  .item-wrap {
    width: 25%;
    display: flex;
    padding: 10px 0;
    .label {
      width: 100px;
      flex-shrink: 0;
      color: #666666;
    }
    .value {
      color: #333333;
      padding-right: 10px;
    }
  }
}
.apply-logs {
  padding: 10px 20px;
  .log-item {
    position: relative;
    padding: 1px 0 1px 20px;
    &::before {
      content: "";
      position: absolute;
      background-color: #eeeeee;
      height: 50%;
      top: 0;
      left: 0;
      width: 2px;
      z-index: 1;
    }
    &::after {
      content: "";
      position: absolute;
      background-color: #eeeeee;
      height: 50%;
      top: 50%;
      left: 0;
      width: 2px;
      z-index: 1;
    }
    &:first-child {
      &::before {
        display: none;
      }
    }
    &:last-child {
      &::after {
        display: none;
      }
      .log-info {
        margin-bottom: 0;
      }
    }
  }
  .log-icon {
    position: absolute;
    font-size: 18px;
    left: -8px;
    top: 50%;
    background-color: #fff;
    transform: translateY(-50%);
    z-index: 10;
  }
  .log-info {
    font-size: 14px;
    line-height: 1.8;
    color: #666666;
    padding: 10px 20px;
    border-radius: 5px;
    margin: 5px 0;
    background-color: #f8f8f8;
    max-width: 800px;
    display: flex;
    align-items: center;
  }
  .info-main {
    flex: 1;
    padding-right: 20px;
  }
  .operationTime {
    color: #666666;
  }
}
.dialog-footer {
  text-align: right;
  padding-top: 10px;
}
</style>